/**
 * Staging Environment Configuration
 * This file contains environment-specific settings for the staging deployment
 */
export const environment = {
    // Environment detection - used by AuthContext and settings
    production: true,
    
    // API mocking disabled in staging
    useMockApi: false,
    
    // Main API URL - Express backend
    // Using relative path since staging is served from same domain
    ctLiteApiUrl: '/express-api/api',
    
    // Express backend base URL
    expressApiUrl: '/express-api',

    // Firebase configuration - staging Firebase project
    firebase: {
        apiKey: 'AIzaSyAJAoeJUP7cOsCJn9cU9leCT3nd9riLDls',
        authDomain: 'auth-staging.coinfox.io',
        projectId: 'cointracking-lite-staging',
        storageBucket: 'cointracking-lite-staging.firebasestorage.app',
        messagingSenderId: '914866083984',
        appId: '1:914866083984:web:651c7a2cbb1074b9256015',
        useEmulator: false,
    },
    
    // Google OAuth configuration - staging credentials
    googeClientId: '914866083984-nm5d5aibe867hvlenh13ufd6c3v40u6o.apps.googleusercontent.com',
    googleLoginCallbackUrl: 'https://staging.coinfox.io/auth/callback',
};
